module.exports = "<div class=\"stub-config-panel q-card q-card-white\"> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ConfigPanel/html/configPanel.html
// module id = 1174
// module chunks = 1